import CustomListPage from './CustomListPage';

export const CustomListPageConfig = {
  routes: [
    {
      path: '/pages/custom',
      exact: true,
      component: CustomListPage,
    },
  ],
};
